import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { HttpClientCachingService } from '../../../../../core/cache/custom-http-client-caching.service';
import { RECEPCION_VEHICULO_REQUEST } from './recepcion-vehiculo-request';
import { GlobalsService } from '../../../../../core/services/globals.service';
import { InformationBoxSummaryService } from '../../../../../core/components/informationBoxSummary/information-box-summary.service';
import { AuthService } from '../../../../../core/services/auth.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class RecepcionVehiculoService {

    customerSelected: any;
    vehicleSelected: any;
    datosCustomDialog: any;

    recepcionRequestCopy;

    recepcionRequest;

    constructor(
        private http: HttpClient,
        private httpCache: HttpClientCachingService,
        private _globalsService: GlobalsService,
        private infoSummary: InformationBoxSummaryService,
        private userService: AuthService
    ) {
        this.recepcionRequestCopy = JSON.stringify(Object.assign(RECEPCION_VEHICULO_REQUEST));
        this.setCopyRequest();

    }

    setCopyRequest() {
        this.recepcionRequest = JSON.parse(this.recepcionRequestCopy);
        this.customerSelected = undefined;
        this.vehicleSelected = undefined;
        this.infoSummary.setdataOR(this.recepcionRequest.inputValue);
        if (this.datosCustomDialog) {
            this.datosCustomDialog.WorkLineList = [];
            this.datosCustomDialog.Receptionist = null;
            this.datosCustomDialog.AuthorizationNumber = null;
            this.datosCustomDialog.Destination = null;
            this.datosCustomDialog.DestinationDescription = null;
            this.datosCustomDialog.LocCarroceria = null;
            this.datosCustomDialog.LocMecanica = null;
            this.datosCustomDialog.Notes = null;
            this.datosCustomDialog.ContactEmail = null;
            this.datosCustomDialog.ContactPhoneNumber = null;
            this.datosCustomDialog.PreviewedDeliveryDate = null;
            this.datosCustomDialog.Receptionist = null;
            this.datosCustomDialog.PreviewedDeliveryDate = null;
        }
    }

    setDatosVehiculo() {
        //vehiculo
        this.recepcionRequest.inputValue.Chassis = this.vehicleSelected.Chassis;
        this.recepcionRequest.inputValue.CitOpb = this.vehicleSelected.OpbCode;
        this.recepcionRequest.inputValue.Km = this.vehicleSelected.KM || this.vehicleSelected.KM !== '' ? this.vehicleSelected.KM : 0;
        this.recepcionRequest.inputValue.ModelCode = this.vehicleSelected.ModelCode;
        this.recepcionRequest.inputValue.ModelDescription = this.vehicleSelected.Description;
        this.recepcionRequest.inputValue.ModelYear = this.vehicleSelected.ModelYear;
        this.recepcionRequest.inputValue.Plate = this.vehicleSelected.PlateNumber;
        this.recepcionRequest.inputValue.ServiceFuelLevel = this.vehicleSelected.FuelLevel;
        this.recepcionRequest.inputValue.Vehicle = this.vehicleSelected;
        this.recepcionRequest.inputValue.VehicleBrandCode = this.vehicleSelected.VehicleBrand.BrandCode;
        this.recepcionRequest.inputValue.Vin = this.vehicleSelected.Vin;

        if (this.customerSelected) {
            //customer
            this.setCustomerReceptionRequest();
        }
        this.infoSummary.setdataOR(this.recepcionRequest.inputValue);

    }

    private setCustomerReceptionRequest() {
        this.recepcionRequest.inputValue.CustomerAddress = this.customerSelected.Address;
        this.recepcionRequest.inputValue.CustomerCap = this.customerSelected.PostalCode;
        this.recepcionRequest.inputValue.CustomerCity = this.customerSelected.City;
        this.recepcionRequest.inputValue.CustomerCode = this.customerSelected.CustomerCode;
        this.recepcionRequest.inputValue.CustomerEmail = this.customerSelected.Email;
        this.recepcionRequest.inputValue.CustomerFiscalCode = this.customerSelected.FiscalCode;
        this.recepcionRequest.inputValue.CustomerIdentificationTypeCode = this.customerSelected.IdentificationType;
        this.recepcionRequest.inputValue.CustomerName1 = this.customerSelected.CustomerName;
        this.recepcionRequest.inputValue.CustomerPrivacy = this.customerSelected.Privacy;
        this.recepcionRequest.inputValue.CustomerProvince = this.customerSelected.Province;
        this.recepcionRequest.inputValue.CustomerSearchClientCode = this.customerSelected.CustomerCode;
        this.recepcionRequest.inputValue.CustomerTelephoneHome = this.customerSelected.TelephoneHome;
        this.recepcionRequest.inputValue.TelephonePortable = this.customerSelected.TelephonePortable;
        this.recepcionRequest.inputValue.ThirdParty = this.customerSelected;
        this.recepcionRequest.inputValue.CustomerIsoCode = this.customerSelected.IsoCode;
    }

    setDatosVehiculoForm(form) {
        let formParams = form.getRawValue();

        //vehiculo
        this.recepcionRequest.inputValue.VehicleBrandCode = formParams && formParams.BrandCode ? formParams.Brand.BrandCode : '';
        this.recepcionRequest.inputValue.ModelDescription = formParams.ModelDescription ? formParams.ModelDescription : this.vehicleSelected.Description;
        this.recepcionRequest.inputValue.OrganizationNumber = formParams.OrganizationNumber ? formParams.OrganizationNumber : this.recepcionRequest.inputValue.OrganizationNumber;
        //  this.recepcionRequest.inputValue.Chassis = this.vehicleSelected.Chassis;
        //  this.recepcionRequest.inputValue.CitOpb = formParams.OpbCode ? formParams.OpbCode : this.vehicleSelected.OpbCode;
        //  this.recepcionRequest.inputValue.Km = formParams.KM || formParams.KM !== '' ? formParams.KM : 0;
        //  this.recepcionRequest.inputValue.ModelCode = this.vehicleSelected.ModelCode;
        //  this.recepcionRequest.inputValue.Plate = formParams.Matricula ? formParams.Matricula : this.vehicleSelected.PlateNumber;
        this.recepcionRequest.inputValue.ServiceFuelLevel = formParams.FuelLevel ? formParams.FuelLevel : this.vehicleSelected.FuelLevel;
        //  this.recepcionRequest.inputValue.Vin = formParams.VIN ? formParams.VIN : this.vehicleSelected.Vin;

         if (this.recepcionRequest.inputValue.Vehicle) {
            this.recepcionRequest.inputValue.Vehicle.Type = formParams.Type;
            this.recepcionRequest.inputValue.VehicleType = formParams.Type;
            this.recepcionRequest.inputValue.Vehicle.BrandCode = formParams && formParams.BrandCode ? formParams.Brand.BrandCode : '';
            this.recepcionRequest.inputValue.Vehicle.Description = formParams.ModelDescription ? formParams.ModelDescription : this.vehicleSelected.Description;
            this.recepcionRequest.inputValue.Vehicle.OrganizationNumber = formParams.OrganizationNumber ? formParams.OrganizationNumber : this.recepcionRequest.inputValue.OrganizationNumber;
            this.recepcionRequest.inputValue.Vehicle.FuelLevel = formParams.FuelLevel ? formParams.FuelLevel : this.vehicleSelected.FuelLevel;
            // this.recepcionRequest.inputValue.Vehicle.OpbCode = formParams.OpbCode ? formParams.OpbCode : this.vehicleSelected.OpbCode;
        }
         this.infoSummary.setdataOR(this.recepcionRequest.inputValue);
    }

    setDatosCliente() {
        this.setCustomerReceptionRequest();
        this.infoSummary.setdataOR(this.recepcionRequest.inputValue);
    }

    setDatosCustomDialog(dc?: any) {
        if (dc) {
            this.datosCustomDialog = dc;
        }

        if (this.userService.getDataPais() === 'pt') {
            this.datosCustomDialog.WorkLineList[0].InsuranceFranchiseBilling = 2;
            this.datosCustomDialog.WorkLineList[0].WorkLineType = 1;
            this.datosCustomDialog.WorkLineList[0].SagaiPartialAcceptedPrice = 0;
        }

        this.recepcionRequest.inputValue.WorkLineList = this.datosCustomDialog.WorkLineList ? [...this.datosCustomDialog.WorkLineList] : [];
        this.recepcionRequest.inputValue.Receptionist = this.datosCustomDialog.Receptionist ? this.datosCustomDialog.Receptionist : null;
        this.recepcionRequest.inputValue.AuthorizationNumber = this.datosCustomDialog.AuthorizationNumber ? this.datosCustomDialog.AuthorizationNumber : null;
        this.recepcionRequest.inputValue.Destination = this.datosCustomDialog.Destination ? this.datosCustomDialog.Destination : null;
        this.recepcionRequest.inputValue.DestinationDescription = this.datosCustomDialog.DestinationDescription ? this.datosCustomDialog.DestinationDescription : null;
        this.recepcionRequest.inputValue.LocCarroceria = this.datosCustomDialog.LocCarroceria ? this.datosCustomDialog.LocCarroceria : null;
        this.recepcionRequest.inputValue.LocMecanica = this.datosCustomDialog.LocMecanica ? this.datosCustomDialog.LocMecanica : null;
        this.recepcionRequest.inputValue.Notes = this.datosCustomDialog.Notes ? this.datosCustomDialog.Notes : null;
        this.recepcionRequest.inputValue.ContactEmail = this.datosCustomDialog.ContactEmail ? this.datosCustomDialog.ContactEmail : null;
        this.recepcionRequest.inputValue.ContactPhoneNumber = this.datosCustomDialog.ContactPhoneNumber ? this.datosCustomDialog.ContactPhoneNumber : null;
        this.recepcionRequest.inputValue.ReceptionistCode = this.datosCustomDialog.Receptionist ? this.datosCustomDialog.Receptionist.ReceptionistCode : null;

        this.recepcionRequest.inputValue.PreviewedDeliveryDate = this.datosCustomDialog.PreviewedDeliveryDate ? this._globalsService.getDateFormatForServer(this.datosCustomDialog.PreviewedDeliveryDate) : null;
        //this.recepcionRequest.inputValue.RepairData = this._globalsService.getDateFormatForServer(Date.now());
        this.recepcionRequest.inputValue.RepairData = this.userService.getWorkingDate();
        this.recepcionRequest.inputValue.RegistrationDate = this.vehicleSelected.RegistrationDate;


        this.recepcionRequest.inputValue.PRODUCTIONDATA = this._globalsService.getDateFormatForServer(Date.now());


        if (this.datosCustomDialog.Courtesies && this.datosCustomDialog.Courtesies.length > 0) {
            for (let c of this.datosCustomDialog.Courtesies) {
                if (this.customerSelected.Courtesy === c.ID) {
                    this.recepcionRequest.inputValue.CustomerCourtesy = c;
                    break;
                }
            }
        } else {
            this.recepcionRequest.inputValue.CustomerCourtesy = {}
        }

        this.infoSummary.setdataOR(this.recepcionRequest.inputValue);

    }



    getAll(url: string, params: object) {
        return this.http.post<any>(url, params);
    }


    getDataAllVehicles() {
        const params = {
            'searchValue': '',
            'pageInfo': {
                'Number': 1,
                'Size': 250
            }
        };
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.Workshop}${environment.SessionService.ENDPOINT.VehicleBrands}`;
        return this.httpCache.post<any>(_URL_, params);
    }

    getIsoCodes(): Observable<any[]> {
        return this.http.post<any>(`${environment.ENTORNO}Services/General/ISOCodesService.svc/GetAll`, {}).pipe(
            map(result => { return result.Response; })
        );
    }

}
